import React from "react";

export const UomTableHead = (props) => {
  return (
    <React.Fragment>
      <thead>
        <tr className="super_admin_all_users_table_head">
          <th className="f12-400" style={{ width: "10%", fontWeight: 400 }}>
            {props.serialNo}
          </th>
          <th className="f12-400" style={{ width: "15%", fontWeight: 400 }}>
            {props.name}
          </th>
          <th className="f12-400" style={{ width: "15%", fontWeight: 400 }}>
            {props.code}
          </th>
          <th className="f12-400" style={{ width: "15%", fontWeight: 400 }}>
            {props.system}
          </th>
          <th className="f12-400" style={{ width: "17%", fontWeight: 400 }}>
            <p className="col-12 px-0">{props.classification}</p>
            <p>{props.classificationTwo}</p>
          </th>
          <th className="f12-400" style={{ width: "18%", fontWeight: 400 }}>
            {props.status}
          </th>
          <th className="f12-400" style={{ width: "10%", fontWeight: 400 }}>
            Actions
          </th>
        </tr>
      </thead>
    </React.Fragment>
  );
};
